import React from "react";
import { createStackNavigator } from "@react-navigation/stack";

import { useTranslation } from "react-i18next";
import Home from "./Home";
import Details from "./Details";
const Stack = createStackNavigator();

export interface BookingStackProps { }

const HomeStack: React.FC<BookingStackProps> = () => {
  const { t, i18n } = useTranslation();
  return (
    <Stack.Navigator>
      <Stack.Screen
        name="calendar"
        component={Home}
        options={{
          title: t("HEADER_HOME"),
          headerStyle: {
            backgroundColor: "#D71D9A",
          },
          headerTintColor: "#fff",
          headerTitleStyle: {
            fontWeight: "bold",
          },
        }}
      />
      <Stack.Screen
        name="details"
        component={Details}
        options={{
          title: t("HEADER_DETAIL"),
          headerStyle: {
            backgroundColor: "#D71D9A",
          },
          headerTintColor: "#fff",
          headerTitleStyle: {
            fontWeight: "bold",
          },
        }}
      />
    </Stack.Navigator>
  );
};

export default HomeStack;
